import { render, staticRenderFns } from "./LessonExam.vue?vue&type=template&id=e0571d4e&scoped=true&"
import script from "./LessonExam.vue?vue&type=script&lang=js&"
export * from "./LessonExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0571d4e",
  null
  
)

export default component.exports